import { SearchSelect } from '@jurnee/common/src/components/Select';
import { countriesList } from './list';

interface Props {
  onChange(data: { label: string, value: string } | null): void;
  value: string;
}

export function CountrySelector({ value, onChange }: Props) {
  return (
    <SearchSelect<string>
      options={countriesList}
      openMenuOnFocus={true}
      maxMenuHeight={200}
      placeholder="Select"
      onChange={onChange}
      value={countriesList.find(x => x.value === value)}
    />
  );
}